import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import hotelsEn from "./locales/en/hotels.json";
import usersEn from "./locales/en/users.json";
import requestsEn from "./locales/en/requests.json";
import amenitiesEn from "./locales/en/amenities.json";
import servicesEn from "./locales/en/services.json";
import chatsEn from "./locales/en/chats.json";
import commonEn from "./locales/en/common.json";
import categoriesEn from "./locales/en/categories.json";
import staffEn from "./locales/en/staff.json";
import feedbacksEn from "./locales/en/feedbacks.json";
import billingEn from "./locales/en/billing.json";
import NotificationsEN from "./locales/en/notifications.json";
import reservationEN from "./locales/en/reservation.json";
import layoutEn from "./locales/en/layout.json";
import tenantsEn from "./locales/en/tenants.json";
import subscriptionsEn from "./locales/en/subscriptions.json";
import accountEn from "./locales/en/account.json";
import partnersEn from "./locales/en/partners.json";
import pmsEn from "./locales/en/pms.json";
import staffScheduleEn from "./locales/en/staffSchedule.json";
import monitoringEn from "./locales/en/monitoring.json";
import ssoEn from "./locales/en/sso.json";
import modulesEn from "./locales/en/modules.json";
import mobileSettingsEn from "./locales/en/mobileSettings.json";
import regionsEn from "./locales/en/regions.json";
import storageEn from "./locales/en/storage.json";
import analyticsEn from "./locales/en/analytics.json";
import communicationChannelsEn from "./locales/en/communicationChannels.json";
import dataDeletionEn from "./locales/en/dataDeletion.json";
import dataExportEn from "./locales/en/dataExport.json";

const resources = {
  en: {
    translation: {
      hotels: hotelsEn,
      users: usersEn,
      requests: requestsEn,
      amenities: amenitiesEn,
      services: servicesEn,
      chats: chatsEn,
      staff: staffEn,
      common: commonEn,
      feedbacks: feedbacksEn,
      billing: billingEn,
      notifications: NotificationsEN,
      reservation: reservationEN,
      layout: layoutEn,
      tenants: tenantsEn,
      subscriptions: subscriptionsEn,
      account: accountEn,
      partners: partnersEn,
      pms: pmsEn,
      staffSchedule: staffScheduleEn,
      monitoring: monitoringEn,
      sso: ssoEn,
      modules: modulesEn,
      mobileSettings: mobileSettingsEn,
      regions: regionsEn,
      storage: storageEn,
      analytics: analyticsEn,
      communicationChannels: communicationChannelsEn,
      dataDeletion: dataDeletionEn,
      dataExport: dataExportEn,
    },
    categories: categoriesEn,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  debug: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
